import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const sundayPollAddApi = createAsyncThunk(
    'auth//sunday-polls/add',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.sundayPollsAction("create-poll", 0), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const sundayPollAddSlice = createSlice({
    name: 'sundayPoll Add',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(sundayPollAddApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(sundayPollAddApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(sundayPollAddApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const sundayPollAddReducer = sundayPollAddSlice.reducer